import { httpGet } from 'utils';

interface IFetchNumberOfStocksAgainstBidsResponse {
  data: [
    {
      numberOfBids: number;
      physicalLwin18s: string[];
    },
  ];
  count?: number;
}

export const fetchNumberOfStocksAgainstBids = () => {
  const path = 'portal/NumberOfStocksAgainstBids';
  return httpGet<IFetchNumberOfStocksAgainstBidsResponse>(path);
};
